import api from "../helpers/interceptor";

export const RequestListing = async (payload) =>
  await api.get(
    `/collegeAdmin/getCollegeRequests?page=${payload.page}&limit=${payload.limit}&search_key=${payload.search_key}`
  );

// Get Details
export const GetCollegeReqDetails = async (id) =>
  await api.get(`/collegeAdmin/getCollegeDetails?request_id=${id}`);

export const GetRepresentativeDetails = async (id) =>
  await api.get(`/collegeAdmin/getClgRepresentativeDetails?request_id=${id}`);

export const GetSignedDetails = async (id) =>
  await api.get(`/collegeAdmin/getClgSignedData?request_id=${id}`);

export const GetVirtualDetails = async (id) =>
  await api.get(`/collegeAdmin/getClgVVDetails?request_id=${id}`);

// status
export const ChangeStatus = async (payload) =>
  await api.put(`/collegeAdmin/approveRejectCollege`, payload);

//SignedData

export const GetSignedData = async (id) =>
  await api.get(`/collegeAdmin/getClgSignedData?request_id=${id}`);

// Virtual Ver
export const GetVirtualVerify = async (id) =>
  await api.get(`/collegeAdmin/getClgVVDetails?request_id=${id}`);
